import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";
import "../styles.css";

function AddMultipleToCart() {
  useEffect(() => {
    // insert script tag
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_CS_JS_SCRIPT;
    // add charitystack-embed as id
    script.id = "charitystack-embed";
    // set data-id to M_glZDDEVkfj
    script.dataset.id = "M_ZfIY2UFdJW";
    // make script defer
    script.defer = true;
    // append script to head
    document.body.appendChild(script);

    // create an event listener that listens for a message from the iframe
    window.addEventListener("message", (event) => {
      if (event.data.action !== "IFRAME_LOADED") {
        return;
      }
      const data = JSON.parse(event.data.data);
      const iframeID = data.elementID;
      const iframe = document.getElementById(iframeID);

      console.log("iframeID", iframeID);
      console.log("iframe", iframe);

      // store css content from styles.css into a variable
      const cssContent = `
                #57f555bd-771f-4992-a749-65a98e5f328d-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
                    #60ec3aa9-7e3f-4e96-99c3-5440931ada67-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
            `;

      // #60ec3aa9-7e3f-4e96-99c3-5440931ada67-CS-fundraising-bar-pill {
      //         background-color: red !important;
      //     }

      //     #60ec3aa9-7e3f-4e96-99c3-5440931ada67-CS-fundraising-bar-pill-text {
      //         font-size: 300px !important;
      //     }

      // send CSS content to iframe
      iframe.contentWindow.postMessage(
        {
          action: "ADD_CSS_CONTENT",
          entity: "CHARITYSTACK",
          sender: "PARENT_WEBSITE",
          receiver: "FUNDRAISING_BAR",
          data: cssContent,
          id: iframeID,
        },
        "*",
      );
    });
  }, []);

  return (
    <div className="App">
      {/* <div
                style={{
                    position: "fixed",
                    top: "0px",
                    width: "100%",
                    height: "100px",
                    background: "linear-gradient(to bottom, #0066ff, #ff0000)",
                    zIndex: "99999",
                }}></div> */}

      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
        sollicitudin enim et dolor pellentesque, et aliquam velit vestibulum.
        Morbi condimentum felis eget tortor congue, id convallis turpis
        fringilla. Duis rutrum tellus et sapien
      </div>

      <div
        data-entity="FUNDRAISING_BAR"
        data-source="CharityStack"
        id="f0a97b62-f1cd-4768-bc1d-7f388c6f34c4"
      ></div>

      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="355eca2d-e6d6-4fac-b028-9d2dfd9e0f4a"
      ></div>
      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="5d8a3c2e-0827-4de6-b82f-ba20420a5583"
      ></div>

      <div>
        Cras ullamcorper, justo sit amet sagittis commodo, metus dui consequat
        urna, eget sollicitudin metus erat ut dui. Proin aliquam lacus sit amet
        dolor vulputate tincidunt. Proin gravida mauris ex, nec bibendum urna
        pulvinar vitae. Nullam non pharetra purus. Proin bibendum
      </div>
    </div>
  );
}

export default AddMultipleToCart;
